module.exports = __webpack_public_path__ + "images/emoji/chicken.4c74b862ce09d02fe761.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/chicken.png
// module id = Fu8l
// module chunks = 14